import AppMenuChapter from "../components/AppMenuChapter";
import { connect } from "react-redux";
import { toggleFavorite, goToSlide, setUIVisibilityState } from "../actions";
import { isSlideAvailable, getSlideIndex, getTrackableSlidesInChapter, getChapterIndexes } from "../utils/helpers";
var mapStateToProps = function(state, ownProps) {
    var chapter = state.uiVisibilityState.favOnly && ownProps.chapter ? ownProps.chapter : state.nodes.find(function(n) {
        return n.id === ownProps.nodeId;
    });
    var trackableSlides = getTrackableSlidesInChapter(chapter, state);
    var subNodes = [];
    var collectNodes = function(n) {
        var _loop = function(i) {
            var _node = state.nodes.find(function(_n) {
                return _n.id === n.c[i];
            });
            if (_node) {
                subNodes.push(_node.id);
            }
            if ((_node === null || _node === void 0 ? void 0 : _node.target_type) === "Filter") {
                collectNodes(_node);
            }
        };
        for(var i = 0; i < n.c.length; i++)_loop(i);
    };
    if (chapter) {
        collectNodes(chapter);
    }
    return {
        startsOpen: state.uiVisibilityState.favOnly ? true : state.currentSlide ? subNodes.indexOf(state.currentSlide) > -1 : false,
        currentSlide: state.currentSlide,
        chapter: chapter,
        chapterAvailable: state.nodes.filter(function(n) {
            return chapter.c.indexOf(n.id) > -1;
        }).some(function(n) {
            return isSlideAvailable(n, state);
        }),
        isComplete: function(id) {
            return state.completed.indexOf(id) > -1;
        },
        isChapterCompleted: function(chapterId) {
            var chapter = state.nodes.find(function(n) {
                return n.id === chapterId;
            });
            return chapter && chapter.c.every(function(slide) {
                return state.completed.includes(slide);
            }) || false;
        },
        isAvailable: function(slide) {
            return isSlideAvailable(slide, state);
        },
        isFavorite: function(id) {
            return state.favorites.indexOf(id) > -1;
        },
        getNodes: function(ids) {
            return state.nodes.filter(function(n) {
                return ids.indexOf(n.id) > -1;
            });
        },
        getFirstChapterSlide: function(chapterId) {
            var chapter = state.nodes.find(function(n) {
                return n.id === chapterId;
            });
            return chapter && chapter.c && chapter.c.length > 0 ? chapter.c[0] : null;
        },
        isCurrentSlideInChapter: function(chapterId) {
            var chapter = state.nodes.find(function(n) {
                return n.id === chapterId;
            });
            return chapter && chapter.c.indexOf(state.currentSlide) > -1;
        },
        getSlideIndex: function(id) {
            return getSlideIndex(id, state);
        },
        getChapterIndexes: function(chapterId) {
            return getChapterIndexes(chapterId, state);
        },
        trackableSlidesCount: trackableSlides.length,
        trackableCompletedSlidesCount: trackableSlides.filter(function(id) {
            return state.completed.indexOf(id) > -1;
        }).length,
        favCount: state.favorites.length,
        getSlideStatus: function(id) {
            return state.api ? state.api.getSlideStatus(id) : "";
        },
        getNonRegularChapterProgress: function getNonRegularChapterProgress(chapterId) {
            var chapter = state.nodes.find(function(n) {
                return n.id === chapterId;
            });
            var trackableSlides = getTrackableSlidesInChapter(chapter, state);
            return {
                trackableSlidesCount: trackableSlides.length,
                trackableCompletedSlidesCount: trackableSlides.filter(function(id) {
                    return state.completed.indexOf(id) > -1;
                }).length
            };
        }
    };
};
var mapDispatchToProps = function(dispatch, _ownProps) {
    return {
        toggleFavorite: function(id) {
            dispatch(toggleFavorite({
                id: id
            }));
        },
        goTo: function(id) {
            dispatch(goToSlide({
                id: id
            }));
            dispatch(setUIVisibilityState({
                state: {
                    menu: false
                }
            }));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(AppMenuChapter);
